import _ from "lodash";

export const convertQuizTypeToSelectObject = (objectArray, value) => {
    const findData = objectArray?.find(item => item.value === value)

    return {
      label: findData?.label,
      value: value,
    };
};